<template>
  <div
    :class="classes"
    :style="styles"
  >
    <slot />
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'c-kicker',
  props: {
    color: {
      type: String,
      default: '#717D96',
    },
    weight: {
      type: String,
      default: '700',
      description: '(100-800 / bolder / lighter / normal)',
    },
    align: {
      type: String,
      default: 'left',
    }
  },
  setup(props) {
    const classes = computed(() => [
      'c-kicker',
      `c-kicker--${props.weight}`,
      `c-kicker--${props.align}`,
    ])

    const styles = computed(() => ({
      color: props.color,
    }))

    return {
      classes,
      styles,
    }
  },
}
</script>

<style lang="scss" scoped>
.c-kicker {
  font-size: 14px;
  line-height: 19.6px;

  @media screen and (min-width: 1200px) {
    font-size: 20px;
    line-height: 28px;
  }

  @include textAlign();

  @include weight();
}
</style>
